import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Home from './pages/Home'
import About from './pages/About'
import Contact from './pages/Contact'
import NotFound from './pages/NotFound'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Button from './components/Button'
import ResultPage from './pages/ResultPage'
import CardSlabResult from './results/CardSlabResult'
import ListingPage from './results/ListingPage'
import CardSlabForm from './results/CardSlabForm'
import { ResultProvider } from './context/ResultContext'
import CallTheOffice from './results/CallTheOffice'

function App() {
  return (
    <ResultProvider>
      <Router>
        <div className='flex flex-col h-screen bg-hero-image'>
          <Navbar />

          <Routes>
            <Route
              exact
              path='/'
              element={
                <>
                  <Home />
                </>
              }
            />
            <Route path='/about' element={<About />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/notfound' element={<NotFound />} />
            <Route path='/inventory' element={<ResultPage />} />
            <Route path='/*' element={<NotFound />} />
            {/* <Route path='/inventory/:id' element={<CardSlabResult />} /> */}
            <Route path='/inventory/:id' element={<CallTheOffice />} />
            <Route path='/listingpage' element={<ListingPage />} />
            <Route path='/cardslabform' element={<CardSlabForm />} />
            <Route path='/reserveproduct' element={<CallTheOffice />} />
          </Routes>

          <Footer />
        </div>
      </Router>
    </ResultProvider>
  )
}

export default App
